module.exports = __webpack_public_path__ + "static/media/server.cc748f6a.svg";